import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import Layout from './components/Layout';
import './custom.css';
import { AuthProvider } from './components/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import PublicRoute from './components/PublicRoute';

export default class App extends Component {
  static displayName = App.name;

  render() {
      return (
          <AuthProvider>
              <Layout>
                <Routes>
                  {AppRoutes.map((route, index) => {
                      const { path, element, isPrivate } = route;
                      if (isPrivate) {
                          return <Route key={index} path={path} element={<PrivateRoute>{element}</PrivateRoute>} />;
                      }

                      // Render public routes otherwise
                      return <Route key={index} path={path} element={<PublicRoute>{element}</PublicRoute>} />;
                  })}
                </Routes>
              </Layout>
          </AuthProvider>
    );
  }
}
